import { motion } from "framer-motion"
import { text_motion } from "./_config";
import type { ReactNode } from "react";

interface HeadingProps {
  title: string;
  suptitle: string;
  children?: Readonly<ReactNode>
}


export default function Heading({ suptitle, title, children }: HeadingProps) {
  return (
    <>
      <h2
        className="text-lg lg:text-xl mt-12 lg:mt-6 font-bold text-blue-200"
      >
        {suptitle}
      </h2>
      <h3
        className="text-3xl lg:text-4xl font-bold text-white"
      >
        {title}
      </h3>
      {children}
    </>
  )
}
